import React, { useMemo } from 'react';
import { AvatarLoader } from './AvatarLoader';

function Character({ characterId, characterCount, characterIndex, client }) {
  const position = useMemo(() => {
    if (characterCount > 1) {
      return characterIndex === 0 ? [-0.2, 0, 0] : [0.2, 0, 0];
    }
    return [0, 0, 0];
  }, [characterCount, characterIndex]);

  return (
    <group frustumCulled position={position}>
      <AvatarLoader client={client} characterId={characterId} />
    </group>
  );
}

export default Character;
